import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faChartLine} from '@fortawesome/free-solid-svg-icons'

import './csvbutton.css'

export default class ChartButton extends Component {

  render() {
    const chartCallback = this.props.chartClick ?? (()=>{});
    return (
      <span className="csvbutton-dot" onClick={() => chartCallback()}>
        <FontAwesomeIcon className="icon-nudge" icon={faChartLine} color="#257461" />
      </span>  
    )
  }
}
